import MembersMerchandise from "./MembersMerchandise";

export default function MembersMerchandiseTab() {
  return (
    <div className="p-4 md:p-6">
      <h2 className="text-2xl font-semibold mb-6 text-taekwondo-red">
        OMAC Merchandise
      </h2>
      <p className="text-sm text-gray-700 mb-4">
        Browse available uniforms, apparel, and other OMAC-branded items. Please
        speak with an instructor to place or confirm an order.
      </p>
      <MembersMerchandise />
    </div>
  );
}


